import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Accordion from '..'
import '../index.scss'

export default function SectionAccordion ({ title, className, collapsed, children }) {
  const [show, setShow] = useState(!collapsed)

  const toggleShow = () => {
    setShow((currentValue) => !currentValue)
  }

  return (
    <>
      <Accordion title={title} toggleShow={toggleShow} show={show} className={className} />
      <div>{show && children}</div>
    </>
  )
}

SectionAccordion.defaultProps = {
  collapsed: false,
}

SectionAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  collapsed: PropTypes.bool,
}
